
import React from 'react';
import PropTypes from 'prop-types';

const NOP = () => {};

export function Star(props) {
  const {
    ratingValue,
    remainder,
    ratingPoint,
    viewerRating,
    activeHoverStart,
    onClick = NOP,
    onHover = NOP,
  } = props;

  const onHoverStar = () => onHover(ratingPoint);
  const offHoverStar = () => onHover(null);
  const onClickStar = () => onClick(ratingPoint);

  let starClassName = 'icon icon-star-outline';
  if (activeHoverStart) { // hover
    if (activeHoverStart >= ratingPoint) {
      starClassName = 'icon icon-star star-hover';
    }
  } else if (viewerRating > 0) { // viewer rating
    if (viewerRating >= ratingPoint) {
      starClassName = 'icon icon-star star-hover';
    }
  } else if (ratingValue >= 5 || remainder >= 1) {
    starClassName = 'icon icon-star';
  } else if (remainder > 0 && remainder < 1) {
    starClassName = 'icon icon-star-half';
  }

  return (
    <span
      role="button"
      className={starClassName}
      label="star"
      onBlur={offHoverStar}
      onClick={onClickStar}
      onFocus={onHoverStar}
      onKeyDown={onClickStar}
      onMouseOver={onHoverStar}
      onMouseOut={offHoverStar}
      tabIndex={0}
    />
  );
}

Star.propTypes = {
  ratingValue: PropTypes.number,
  ratingPoint: PropTypes.number,
  remainder: PropTypes.number,
  viewerRating: PropTypes.number,
  activeHoverStart: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  onHover: PropTypes.func.isRequired,
};

Star.defaultProps = {
  ratingValue: 0,
  ratingPoint: 0,
  remainder: 0,
  viewerRating: 0,
  activeHoverStart: null,
};

export default Star;
